export default __webpack_public_path__ + "static/15-grid-critters-73c0526e47bf6b338db28fefa174a93a.png";